import React from "react";

const UploadFileIcon: React.FC = () => {
    return (
        <div className="flex flex-col items-center">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8 sm:w-10 sm:h-10 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 16v-4m0 0V8m0 4h4m-4 0H8m8 8h2a2 2 0 002-2v-4a2 2 0 00-2-2h-2m-8 8H6a2 2 0 01-2-2v-4a2 2 0 012-2h2m0 8a2 2 0 002 2h4a2 2 0 002-2M9 4h6a2 2 0 012 2v4a2 2 0 01-2 2H9a2 2 0 01-2-2V6a2 2 0 012-2z"
                />
            </svg>
            <span className="mt-2 text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-300 text-center">
                Drag and drop a file or click to select
            </span>
        </div>
    );
};

export default UploadFileIcon;